<template>
  <CustomHeaderModal
    :isShowModal="isShowModal"
    @cancel="cancel">
    <!-- 詳細 メイン -->
    <template v-if="index === 0">
      <ContextMenuMain
        :chatbot="chatbot"
        :userChatBotBookMark="userChatBotBookMark"
        :users="users"
        :user="user"
        :sitemapRootList="sitemapRootList"
        :sitemapEmploymentList="sitemapEmploymentList"
        :isDetailChatBotSetting="isDetailChatBotSetting"
        :changeChatBotSetting="changeChatBotSetting"
        :uses="uses"
        @cancel="cancel"
        @setIcon="setIcon"
        @changeBookMark="changeBookMark"
        @movePartsEdit="movePartsEdit"
        @updateChatBot="updateChatBot"
        @deleteChatBot="deleteChatBot"/>
    </template>
    <!-- 詳細 パーツリスト -->
    <template v-else-if="index === 1">
      <DetailPartsList
        :chatbot="chatbot"
      />
    </template>
    <!-- 詳細 パーツプレビュー -->
    <template v-else>
      <DetailPartsPreview
        :chatbot="chatbot"
      />
    </template>
  </CustomHeaderModal>
</template>

<script>
import CustomHeaderModal  from '@/components/Modals/CustomHeaderModal'
import ContextMenuMain         from '@/components/ChatBot/organisms/ContextMenuMain'
import DetailPartsList    from '@/components/ChatBot/organisms/DetailPartsList'
import DetailPartsPreview from '@/components/ChatBot/organisms/DetailPartsPreview'
import DetailMail         from '@/components/ChatBot/organisms/DetailMail'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
export default {
  components: {
    CustomHeaderModal,
    ContextMenuMain,
    DetailPartsList,
    DetailPartsPreview,
    DetailMail,
    ModalSelectMedia
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    chatbot: {
      type: Object,
      required: true
    },
    userChatBotBookMark: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    sitemapRootList: {
      type: Array,
      required: true
    },
    sitemapEmploymentList: {
      type: Array,
      required: true
    },
    uses: {
      type: String,
      required: false,
    }
  },
  data () {
    const titleList = [
      'ロボ詳細画面 操作',
      'ロボ詳細画面 パーツ一覧',
      'ロボ詳細画面 パーツプレビュー'
    ]
    const miniTitleList = [
      '操作　画面へ',
      'パーツ一覧へ',
      'プレビューへ'
    ]
    return {
      index: 0,
      titleList: titleList,
      miniTitleList: miniTitleList,
      isDetailChatBotSetting: false,
    }
  },
  methods: {
    changeChatBotSetting (flg) {
      this.isDetailChatBotSetting = flg
    },
    cancel () {
      this.$emit('cancel', false)
    },
    changePage (delta) {
      const len = this.titleList.length
      const changeNum = this.index + delta
      if (changeNum === len) {
        // 超えたら最初に
        this.index = 0
      } else if (changeNum === -1) {
        // マイナスになったら最大へ
        this.index = len - 1
      } else {
        this.index = changeNum
      }
    },
    getPageName (index, delta) {
      const len = this.miniTitleList.length
      const changeNum = index + delta
      let idxStr = 0
      if (changeNum === len) {
        // 超えたら最初に
        idxStr = 0
      } else if (changeNum === -1) {
        // マイナスになったら最大へ
        idxStr = len - 1
      } else {
        idxStr = changeNum
      }
      return this.miniTitleList[idxStr]
    },
    setIcon (data) {
      // iconの更新
      this.$emit('setIcon', data)
    },
    changeBookMark (chatbot) {
      this.$emit('changeBookMark', chatbot)
    },
    movePartsEdit (chatbot) {
      this.cancel()
      this.$emit('movePartsEdit', chatbot)
    },
    updateChatBot (chatbot) {
      this.$emit('updateChatBot', chatbot)
    },
    deleteChatBot (chatbot) {
      this.$emit('deleteChatBot', chatbot)
    },
    createChatBotTags (e) {
      this.$emit('createChatBotTags', e)
    },
    deleteChatBotTags (e) {
      this.$emit('deleteChatBotTags', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.cover-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .card-header-title {
    font-size: 24px;
    font-weight: 600;
  }
  .nav-button {
    color: #a22;
    border: solid 2px #a22;
    font-weight: 800;
  }
  div {
    display: flex;
    button {
      margin: 8px;
    }
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ModalChatBotContextMenu.vue